import { Token } from "../store/global/TokenEnum";

export const TOKEN_COLORS_DARK: Partial<Record<Token, string>> = {
  "1INCH": "#D82122",
  AAVE: "#B353A0",
  APE: "#58A2F8",
  BAL: "#FFFFFF",
  BAT: "#FF5000",
  BLUR: "#FC6C26",
  BUSD: "#F0B90B",
  COMP: "#00D395",
  CRV: "#6DFF8A",
  CTX: "#983CD6",
  DAI: "#F5AC37",
  DYDX: "#6966FF",
  ETH: "#627EEA",
  FTM: "#13B5EC",
  FET: "#FFFFFF",
  FTT: "#5FCADE",
  GALA: "#FFFFFF",
  GMX: "#04CFCE",
  GRT: "#6747ED",
  HFT: "#FFFFFF",
  IMX: "#17B5CB",
  LDO: "#F69988",
  LINK: "#375BD2",
  MAGIC: "#DC2626",
  MATIC: "#A679F2",
  MKR: "#57B4A5",
  MPL: "#FF7900",
  MULTI: "#878AD3",
  RDNT: "#06F2AF",
  SAND: "#0193FB",
  SHIB: "#FFA409",
  SUSHI: "#FB52A1",
  TUSD: "#1B5BFE",
  UNI: "#FF007A",
  USDC: "#2775CA",
  USDP: "#79CD3A",
  USDT: "#009393",
  WBTC: "#F7931A",
  WETH: "#DA3A7A",
  WMATIC: "#2BBDF7",
  YFI: "#006AE3",
  ZRX: "#FFFFFF",
  [Token.CBETH]: "#3971F4",
};
